export default "__VITE_ASSET__BxXSSsME__"